var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.profile
    ? _c(
        "profile-card",
        _vm._b(
          {
            key: _vm.profile.id,
            attrs: { "rotting-days-threshold": _vm.rottingDaysThreshold },
          },
          "profile-card",
          Object.assign({}, _vm.profile),
          false
        )
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }